import { ca } from '@cian/analytics';

export type TJK = 'jk' | 'developer' | 'video' | 'reviews' | 'flats';

export function trackClickJK(label: TJK) {
  ca('event', {
    action: 'blockJK',
    category: 'card',
    label,
    name: 'oldevent',
  });
}
